import { z } from 'zod';

import { zodContractResponseSchema } from '../validations';

/** The buyer is never read from the document, so the request names it. */
export const zodCreateDraftContractFromImportJobPayloadSchema = z.object({
  buyerCompanyId: z.uuid(),
  importJobId: z.uuid(),
});

export { zodContractResponseSchema as zodCreateDraftContractFromImportJobResponseSchema };
